import { createContext, useContext } from "react";
import { useMediaQuery as useMedia } from "react-responsive";

export const MediaQueryContext = createContext(null);

export const MediaQueryProvider = ({ children }) => {
  const MAX_MOBILE = 767;
  const MAX_TABLET = 1024;
  const MAX_LAPTOP = 1279;

  const isDesktop = useMedia({ minWidth: MAX_LAPTOP + 1 });
  const isLaptop = useMedia({ maxWidth: MAX_LAPTOP, minWidth: MAX_TABLET + 1 });
  const isLaptopUp = useMedia({ minWidth: MAX_TABLET + 1 });
  const isLaptopDown = useMedia({ maxWidth: MAX_LAPTOP });
  const isTablet = useMedia({ maxWidth: MAX_TABLET, minWidth: MAX_MOBILE + 1 });
  const isTabletUp = useMedia({ minWidth: MAX_MOBILE + 1 });
  const isTabletDown = useMedia({ maxWidth: MAX_TABLET });
  const isMobile = useMedia({ maxWidth: MAX_MOBILE });

  const context = {
    isDesktop,
    isLaptop,
    isLaptopUp,
    isLaptopDown,
    isTablet,
    isTabletUp,
    isTabletDown,
    isMobile,
  };

  return (
    <MediaQueryContext.Provider value={context}>
      {children}
    </MediaQueryContext.Provider>
  );
};

export const useMediaQuery = () => {
  const context = useContext(MediaQueryContext);

  if (!context) {
    throw new Error(
      "[MediaQueryProvider] Could not find dialog context provider."
    );
  }
  return context;
};
